
import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from '../../utils/api';

import { FetchWorkerReportsRequest, WorkerReportResponse, FetchWorkerReportStatisticsRequest, WorkerReportStatistics } from './types';

export const fetchWorkerReports = createAsyncThunk<WorkerReportResponse, FetchWorkerReportsRequest>(
  'reports/fetchWorkerReports',
  async ({ start_date, end_date, search, overtime, page, orderBy, order }, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      if (start_date) queryParams.append('start_date', start_date);
      if (end_date) queryParams.append('end_date', end_date);
      if (search) queryParams.append('search', search);
      if (overtime !== undefined) queryParams.append('overtime', String(overtime));
      if (orderBy) queryParams.append('order_by', orderBy);
      if (order) queryParams.append('order', order);
      queryParams.append('page', String(page));

      const response = await apiCall<any>(
        'GET',
        `/api/organization/reports/worker/?${queryParams.toString()}`
      );
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchWorkerReportStatistics = createAsyncThunk<WorkerReportStatistics, FetchWorkerReportStatisticsRequest>(
  'reports/fetchWorkerReportStatistics',
  async ({ start_date, end_date, search }, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      if (start_date) queryParams.append('start_date', start_date);
      if (end_date) queryParams.append('end_date', end_date);
      if (search) queryParams.append('search', search);

      const response = await apiCall<any>(
        'GET',
        `/api/organization/reports/worker/statistics/?${queryParams.toString()}`
      );
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
